import React from 'react';
import { type IndicatorColorsMap } from '@bbkAdminComponents/indicators/indicator-colors';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';

import '@bbkAdminComponents/indicators/styles/dot.scss';

type Props = {
  dotColor: keyof typeof IndicatorColorsMap;
  className?: Argument;
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'style'>;
export const DotIndicator: React.FC<React.PropsWithChildren<Props>> = ({
  dotColor,
  className,
  ...restProps
}) => (
  <div className={cs('dot-indicator', dotColor, className)} {...restProps} />
);
